<div layout="column">
    <div class="smile-field-container edit-reply-editor" id="edit-reply-{{ reply.id }}">
        <div class="p-relative">
            @if (!commonDataService.isOneTime && replyTemplateService.allReplyTemplates.length && quillEditor) {
                <sb-quill-reply-templates
                    [isTextContent]="true"
                    [quillEditor]="quillEditor"
                    [reply]="ticket.constraints.areReplyAttachmentsAllowed ? reply : null">
                </sb-quill-reply-templates>
            }

            @if (ticket.constraints.isUserMentioningAllowed) {
                <app-sb-quill-mention
                    [quillEditor]="quillEditor"
                    [usersToMention]="ticket.facebookUsersToMention"
                    [isFacebookMention]="true">
                </app-sb-quill-mention>
            }

            <quill-editor
                id="{{ 'edit-reply-social-media-editor-' + reply.id }}"
                [(ngModel)]="editedReplyText"
                (onContentChanged)="onReplyChanged($event)"
                (onEditorCreated)="
                    parent.onEditorCreated($event, 'reply' + reply.id, 'edit-reply-social-media-editor-' + reply.id);
                    onEditorCreated($event)
                "
                [modules]="quillConfig"
                [formats]="['emoji', 'mention']"
                placeholder="{{ 'Write a reply' | translate }}"
                format="text">
            </quill-editor>
        </div>

        <sb-quill-emoji-picker
            (updateQuillSelection)="parent.updateQuillSelection(parent.quillEditors['reply' + reply.id])"
            (emojiSelect)="
                parent.replyTemplateManagerService.chooseReplyTemplate({
                    $event: $event.$event,
                    templateText: $event.emoji,
                    quillEditor: parent.quillEditors['reply' + reply.id],
                    quillRange: parent.quillRange,
                    isSmile: true,
                })
            ">
        </sb-quill-emoji-picker>
    </div>

    @if (reply.attachments.length) {
        <div class="content-attachments-wrapper">
            @for (
                attachment of reply.attachments | filterContentAttachments: true : reply.attachments.length;
                track attachment
            ) {
                <div class="content-attachments-block">
                    <button
                        type="button"
                        class="btn btn-icon btn-close btn-transparent"
                        aria-label="Close"
                        (click)="deleteAttachment(attachment)">
                        <sb-inline-svg
                            class="icon icon-close"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                        </sb-inline-svg>
                    </button>

                    <sb-file-view
                        [attachment]="attachment"
                        [permalink]="ticket.permalink"
                        [isFilePreviewInModal]="true">
                    </sb-file-view>
                </div>
            }

            @if ((reply.attachments | filterContentAttachments: false : reply.attachments.length).length) {
                <div class="attachments-block">
                    @for (attachment of reply.attachments; track attachment; let idx = $index) {
                        @if (!attachment.isContentPart) {
                            <sb-file-preview
                                class="file-container"
                                [isRemoveFromServer]="false"
                                [attachment]="attachment"
                                [fileIndex]="idx"
                                [canBeRemoved]="true"
                                [attachments]="reply.attachments"
                                [permalink]="ticket.permalink">
                            </sb-file-preview>
                        }
                    }

                    <div class="clearfix"></div>
                </div>
            }
        </div>
    }

    @if (!reply.isDraft || ticket.isTicketCanBeReplied) {
        <div class="mt-2">
            <div class="clearfix"></div>

            <div class="buttons-panel text-end">
                @if (
                    ticket.constraints.isGifReplySupported &&
                    !(reply.attachments | filterContentAttachments: true : reply.attachments.length).length
                ) {
                    <sb-giphy-picker
                        (add)="addGifAttachment($event)"
                        [isDisabled]="reply.attachments.length >= ticket.constraints.maxReplyAttachmentsCount">
                    </sb-giphy-picker>
                }

                @if (!commonDataService.isOneTime) {
                    <button
                        class="btn btn-icon"
                        (click)="
                            parent.openReplyTemplatesModal(
                                $event,
                                parent.quillEditors['reply' + reply.id],
                                ticket.constraints.areReplyAttachmentsAllowed ? reply : null
                            )
                        "
                        tooltip="{{ 'Insert a saved template' | translate }}"
                        container="body">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'">
                        </sb-inline-svg>
                    </button>
                }

                <button
                    id="btn-signature"
                    [disabled]="reply.isSendingReply"
                    (click)="parent.setSignature(replyModel, null, $event, false)"
                    class="btn btn-icon"
                    tooltip="{{ 'Signature' | translate }}"
                    container="body">
                    <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'">
                    </sb-inline-svg>
                </button>

                @if (ticket.isEditable && ticket.constraints.areReplyAttachmentsAllowed) {
                    <button
                        class="btn btn-icon"
                        (click)="
                            parent.openAttachmentsModal(
                                reply.attachments,
                                reply.attachments.length,
                                ticket.constraints.maxReplyAttachmentsCount
                            )
                        "
                        tooltip="{{ 'Attachments' | translate }}"
                        container="body"
                        [disabled]="reply.attachments.length >= ticket.constraints.maxReplyAttachmentsCount">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                        </sb-inline-svg>
                    </button>
                }

                @if (!commonDataService.isOneTime && reply.isDraft && !parent.isOneTime) {
                    <button
                        class="btn mt-1 mb-1 btn-outline"
                        [disabled]="
                            reply.isSendingReply ||
                            (reply.message | isInvalidMessage: ticket.constraints : !!reply.attachments.length : false)
                        "
                        (click)="parent.doneEditing(null, reply, false, true, [], [], null, usersToMention)"
                        translate>
                        save as draft
                    </button>
                }

                <button
                    class="btn"
                    [disabled]="
                        reply.isSendingReply ||
                        (reply.message | isInvalidMessage: ticket.constraints : !!reply.attachments.length : false)
                    "
                    (click)="parent.doneEditing(parentReply?.id, reply, true, false, [], [], null, usersToMention)">
                    {{ reply.isDraft ? ('send' | translate) : ('save' | translate) }}
                </button>

                @if (reply.isDraft) {
                    <button class="btn" (click)="parent.deleteReply(reply, parentReply)" translate>cancel</button>
                }

                @if (!reply.isDraft) {
                    <button class="btn" (click)="cancelEditReply(reply)" translate>cancel</button>
                }
            </div>
        </div>
    }
</div>
